export const qk = {
  spaces: () => ['spaces'] as const,
  space: (id: string) => ['spaces', id] as const,
  folders: (spaceId: string, parentId?: string) => ['folders', spaceId, parentId ?? 'root'] as const,
  items: (spaceId: string, folderId?: string) => ['items', spaceId, folderId ?? 'root'] as const,
  item: (id: string) => ['item', id] as const,
  itemVersions: (id: string) => ['item', id, 'versions'] as const,
  itemComments: (id: string) => ['item', id, 'comments'] as const,
  itemShares: (id: string) => ['item', id, 'shares'] as const,
  itemLinks: (id: string) => ['item', id, 'links'] as const,
  itemLinkStats: (id: string, linkId: string) => ['item', id, 'links', linkId, 'stats'] as const,
  myPermissionRequests: (id: string) => ['item', id, 'permission-requests', 'mine'] as const,
  incomingPermissionRequests: (id: string) => ['item', id, 'permission-requests', 'incoming'] as const,
  recent: () => ['items', 'recent'] as const,
  starred: () => ['items', 'starred'] as const,
  trash: () => ['items', 'trash'] as const,
  shared: () => ['items', 'shared'] as const,
  transfers: () => ['transfers'] as const,
  fileRequests: () => ['file-requests'] as const,
  members: () => ['members'] as const,
  storageRequests: () => ['storage-requests'] as const,
  usage: () => ['usage'] as const,
  analytics: () => ['analytics'] as const,
  notifications: () => ['notifications'] as const,
  tags: () => ['tags'] as const,
  people: () => ['people'] as const,
};
